
import Btn from "./Btn.vue";
import FormTextarea from "./FormTextarea.vue";
import FormInput from "./FormInput.vue";

export default {
    components: {FormInput, FormTextarea, Btn},
    props: ['name', 'small', 'noContainer', 'headImage'],
    computed: {
        containerClass() {
            let useContainer = !this.noContainer;
            return {
                'page__container': useContainer,
                'page__container_small': useContainer && this.small,
            }
        },
        pageClass() {
            return {
                'page_with-image': (this.headImage && this.headImage.image),
            }
        },
    },
}
